import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import {SDFField} from './ZSDFBuilder.js';

const Vec2 = ({vec2}) => { 
    const onChange = useCallback(() => {
        vec2.sendObject();
    }, [vec2]);

  return (
        <div className="sdf-builder">
          <SDFField builder={vec2} onChange={onChange} name="x" get={vec2.x}/>
          <SDFField builder={vec2} onChange={onChange} name="y" get={vec2.y}/>
        </div>
  );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Vec2);
